import React, { useRef, useState } from "react"
import PropTypes from "prop-types"
import { theme } from "antd"

import { Drawer } from "@components/Page"
import { EditButton } from "@components/Button"
import { useAppContext } from "@components/AppContext"
import { DRAWER_WIDTH2 } from "@components"
import { readBatchOperation as readOperation } from "@api/services/backstage"

import BatchFilesList from "./BatchFilesList"
import BatchDescription from "./BatchDescription"
import BatchUpdateDrawer from "./BatchUpdateDrawer"
import BatchEmailTemplatePreview from "./BatchEmailTemplatePreview"


const BatchDrawer = ({ table, drawer }) => {
  const updateDrawer = useRef({})

  const [ batch, setBatch ] = useState()
  const [ isRefreshed, setIsRefreshed ] = useState(false)

  const { request } = useAppContext()

  const refreshBatch = id =>
    request(readOperation, { id })
      .then(({ data }) => setBatch(data))
      .then(() => setIsRefreshed(true))

  const onOpen = targetBatch => {
    setBatch(targetBatch)
    refreshBatch(targetBatch.id)
  }

  const onSuccess = async (updatedBatch) => {
    setBatch(updatedBatch)
    refreshBatch(updatedBatch.id)
  }

  const openBatchUpdateDrawer = () =>
    updateDrawer.current.open(batch)

  const {
    name: title = "",
    fileUrl,
  } = batch || {}

  const shouldRenderFiles = batch && !fileUrl

  const extra = <EditButton onClick={openBatchUpdateDrawer} />

  const drawerProps = {
    width: DRAWER_WIDTH2,
    styles: { body: { padding: 0 } },
    destroyOnClose: true,
    extra,
    title,
    drawer,
    onOpen,
  }

  const { token } = theme.useToken()
  const backgroundColor = '#fafafa'
  const { colorSplit, padding, paddingLG } = token

  const headerStyle = {
    borderBottom: `1px solid ${colorSplit}`,
    padding: paddingLG,
    backgroundColor,
  }

  const fileListStyle = {
    borderTop: `1px solid ${colorSplit}`,
    borderBottom: `1px solid ${colorSplit}`,
    padding: paddingLG,
    paddingTop: padding,
    paddingBottom: padding,
  }

  return (
    <Drawer {...drawerProps}>
      {
        batch && (
          <div style={headerStyle}>
            <BatchDescription
              batch={batch}
              isUrlSigned={isRefreshed}
            />
          </div>
        )
      }

      {
        batch && (
          <BatchEmailTemplatePreview batch={batch} />
        )
      }

      {
        shouldRenderFiles && (
          <div style={fileListStyle}>
            <BatchFilesList batch={batch} />
          </div>
        )
      }

      <BatchUpdateDrawer
        table={table}
        drawer={updateDrawer}
        onSuccess={onSuccess}
      />
    </Drawer>
  )
}

BatchDrawer.propTypes = {
  table: PropTypes.shape().isRequired,
  drawer: PropTypes.shape().isRequired,
}

export default BatchDrawer
